import React, { FC, memo } from 'react';
import classNames from 'classnames';

import styles from './index.module.scss';

const SBER_BUSINESS_ONLINE_LOGO_PATH = '/assets/img/sber_business_online_logo.svg';

const SberBusinessOnlineContent: FC = () => (
  <div className={styles.content}>
    <div className={classNames(styles.contentLogo)}>
      <img
        src={SBER_BUSINESS_ONLINE_LOGO_PATH}
        alt=""
      />
    </div>
  </div>
);

export default memo(SberBusinessOnlineContent);
